 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		17: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"framework","2":"594f1012a573cd71c44935a9fa4fd3f93c7c9f44","3":"646e0218","4":"ac03cf241e52427c0083478eb9ce6cb6db0254a0","5":"5171b666ddcdbcb3388dacdd3ba8026a03d59784","6":"312e107096d16a39390bcd8538f7a9b5069b09ab","7":"6e4766b1a2d6009cd9d74b3fe6b28af09a8f622e","8":"7b907173c70da4b4aeec6ca7e21f96ff4806315b","9":"9015f4216c83b04057ed82feef2eb9860af3e05f","10":"932e374e369568cee0ff651a3ff067cdaa2f4da5","11":"b3ead0f8","12":"component---src-pages-terms-quick-task-terms-tsx","13":"component---src-pages-terms-syde-tasker-terms-tsx","14":"d4d9b8e876883efd48e1b12294b6ba592df915bb","15":"fa5f8105","16":"fea29d9f","21":"3e96bda6","22":"4577d2ec","27":"b55cbb4c","29":"component---src-pages-404-js","30":"component---src-pages-about-us-index-js","31":"component---src-pages-about-us-quick-task-about-section-tsx","32":"component---src-pages-about-us-syde-about-section-tsx","33":"component---src-pages-account-index-tsx","34":"component---src-pages-actions-index-tsx","35":"component---src-pages-blogs-index-tsx","36":"component---src-pages-contact-us-index-tsx","37":"component---src-pages-forget-password-index-tsx","38":"component---src-pages-index-tsx","39":"component---src-pages-landing-page-company-trustand-savety-tsx","40":"component---src-pages-login-index-tsx","41":"component---src-pages-messaging-index-tsx","42":"component---src-pages-my-tasks-index-tsx","43":"component---src-pages-privacy-policy-index-tsx","44":"component---src-pages-privacy-policy-quik-tasksection-2-jsx","45":"component---src-pages-privacy-policy-quik-tasksection-jsx","46":"component---src-pages-privacy-policy-syde-taskersection-jsx","47":"component---src-pages-profile-index-tsx","48":"component---src-pages-register-index-tsx","49":"component---src-pages-services-index-tsx","50":"component---src-pages-support-index-tsx","51":"component---src-pages-tasks-index-tsx","52":"component---src-pages-terms-index-tsx","53":"component---src-templates-article-data-tsx","54":"component---src-templates-blog-view-tsx","55":"component---src-templates-category-data-tsx","56":"component---src-templates-services-data-tsx","57":"component---src-templates-task-data-tsx","62":"reactPlayerDailyMotion","63":"reactPlayerFacebook","64":"reactPlayerFilePlayer","65":"reactPlayerKaltura","66":"reactPlayerMixcloud","67":"reactPlayerMux","68":"reactPlayerPreview","69":"reactPlayerSoundCloud","70":"reactPlayerStreamable","71":"reactPlayerTwitch","72":"reactPlayerVidyard","73":"reactPlayerVimeo","74":"reactPlayerWistia","75":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"8679abe89af42d8bb0e0","2":"99348b0bbb37cbcf06ee","3":"10b358256db98fa8b047","4":"f74c07033d1902eccaeb","5":"8bf16d2ee784625eb611","6":"572e7189102b3142f104","7":"8030e7c295f28c74b03b","8":"ba8977206da8890ca24b","9":"56ccddc17b16a51761df","10":"5625b2cc503a66e4867e","11":"141c6dd3039e6cff4a75","12":"838b92f77fa431a57de9","13":"63b4daeabfc9563397a9","14":"e96eb3cb02dd64dff86a","15":"00ca188f808608461870","16":"5e474c2e9ac99f02225d","21":"f58f507400e8bf477ffa","22":"85ff8e285c1345a557a9","27":"6a8b8f7eefcf8c0c7114","29":"d1ccf49f73e6c1339d68","30":"4a5def455088348eeebb","31":"417aee7c1d61e4d3fdae","32":"713ce652ac51db1e1e14","33":"708bb976e4d8c231ea03","34":"162fbb3747fc20451f85","35":"4d1ff7d85b2159d03b40","36":"50e313c3fe53738abb02","37":"6a978135cbc88912dd5c","38":"4b0654a978bf8c304729","39":"cb97a3e894f3b1c1385b","40":"0495d5df958a8a8462b9","41":"5ec9ffcabdb063aa2d51","42":"59d638079e8f362152ae","43":"ae0febf906277aaf14be","44":"e9626baaa512c2433084","45":"3a96ca8f2b6f4ee9682f","46":"53bc12b4e1ec30c1c868","47":"2c2f3727ea3830dc1a06","48":"80af8d79bcf4c294119a","49":"139b023bcbc2fb57260a","50":"cf4ab455f0034b838f41","51":"488561d2bad3fda38ed8","52":"8cb925e523b6e1b33a13","53":"81afad442e61176ffe7f","54":"23e691962b50edeffd95","55":"7929630f9f9c8c418f49","56":"4d7745c8402062c62a8d","57":"6e8e86dcf34410ce71d3","62":"a83cdff35ef5c0e2a331","63":"46e0e8917bc7e8029709","64":"7a3f6a6493a8a00a9482","65":"5eaeb655cf4664c55355","66":"39c8204419aa843a3b4e","67":"fa06bac55ea0eddc927c","68":"df5aa0263c3164f1a461","69":"64bf0d0126325255a210","70":"6e5a8b076d446b15bfe2","71":"a6d3b06aadaa6bdd4afc","72":"cebd3cd3a21c6d14ec1a","73":"c9dbc6f46757b2e4c9c6","74":"538f806a27ab20aefd7d","75":"affa934daa36575e0d4d","76":"80e70ec6489b01525716"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"framework","2":"594f1012a573cd71c44935a9fa4fd3f93c7c9f44","3":"646e0218","4":"ac03cf241e52427c0083478eb9ce6cb6db0254a0","5":"5171b666ddcdbcb3388dacdd3ba8026a03d59784","6":"312e107096d16a39390bcd8538f7a9b5069b09ab","7":"6e4766b1a2d6009cd9d74b3fe6b28af09a8f622e","8":"7b907173c70da4b4aeec6ca7e21f96ff4806315b","9":"9015f4216c83b04057ed82feef2eb9860af3e05f","10":"932e374e369568cee0ff651a3ff067cdaa2f4da5","11":"b3ead0f8","12":"component---src-pages-terms-quick-task-terms-tsx","13":"component---src-pages-terms-syde-tasker-terms-tsx","14":"d4d9b8e876883efd48e1b12294b6ba592df915bb","15":"fa5f8105","16":"fea29d9f","21":"3e96bda6","22":"4577d2ec","27":"b55cbb4c","29":"component---src-pages-404-js","30":"component---src-pages-about-us-index-js","31":"component---src-pages-about-us-quick-task-about-section-tsx","32":"component---src-pages-about-us-syde-about-section-tsx","33":"component---src-pages-account-index-tsx","34":"component---src-pages-actions-index-tsx","35":"component---src-pages-blogs-index-tsx","36":"component---src-pages-contact-us-index-tsx","37":"component---src-pages-forget-password-index-tsx","38":"component---src-pages-index-tsx","39":"component---src-pages-landing-page-company-trustand-savety-tsx","40":"component---src-pages-login-index-tsx","41":"component---src-pages-messaging-index-tsx","42":"component---src-pages-my-tasks-index-tsx","43":"component---src-pages-privacy-policy-index-tsx","44":"component---src-pages-privacy-policy-quik-tasksection-2-jsx","45":"component---src-pages-privacy-policy-quik-tasksection-jsx","46":"component---src-pages-privacy-policy-syde-taskersection-jsx","47":"component---src-pages-profile-index-tsx","48":"component---src-pages-register-index-tsx","49":"component---src-pages-services-index-tsx","50":"component---src-pages-support-index-tsx","51":"component---src-pages-tasks-index-tsx","52":"component---src-pages-terms-index-tsx","53":"component---src-templates-article-data-tsx","54":"component---src-templates-blog-view-tsx","55":"component---src-templates-category-data-tsx","56":"component---src-templates-services-data-tsx","57":"component---src-templates-task-data-tsx","62":"reactPlayerDailyMotion","63":"reactPlayerFacebook","64":"reactPlayerFilePlayer","65":"reactPlayerKaltura","66":"reactPlayerMixcloud","67":"reactPlayerMux","68":"reactPlayerPreview","69":"reactPlayerSoundCloud","70":"reactPlayerStreamable","71":"reactPlayerTwitch","72":"reactPlayerVidyard","73":"reactPlayerVimeo","74":"reactPlayerWistia","75":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"014d3f2c3308db7fb0dc","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
